var YouLi = YouLi ? YouLi : {};
YouLi.Trip = YouLi.Trip ? YouLi.Trip : {};
YouLi.Trip.FlightTracking = YouLi.Trip.FlightTracking ? YouLi.Trip.FlightTracking : {};

(function (YouLi) {
    (function (Trip) {
        (function (FlightTracking) {

            YouLi.Trip.FlightTracking.Enabled = false;

            function toggleCheckFlightState($container) {
                const $dateInput = $container.find('.flight-field-date-input, input[name$="FlightDate"]').first();
                const $airlineInput = $container.find('select[name$="FlightAirlineCode"]').first();
                const $flightNumberInput = $container.find('input[name$="FlightNumber"]').first();
                const $btnCheckFlight = $container.find('.btn-check-flight');

                const flightDate = (($dateInput.val() || '') + '').trim();
                const airlineCode = (($airlineInput.val() || '') + '').trim();
                const flightNumber = (($flightNumberInput.val() || '') + '').trim();

                const hasAllValues =
                    flightDate !== '' &&
                    airlineCode !== '' &&
                    flightNumber !== '';

                $btnCheckFlight.prop('disabled', !hasAllValues);
            }

            function renderFlightCheckResult($container, response) {
                const fieldType = $container.data('field-type');
                const $checkedInput = $container.find('.flight-checked-input, input[name$="FlightChecked"]').first();
                const $resultJsonInput = $container.find('.flight-result-json-input, input[name$="CheckedFlightResultJson"]').first();

                if (!response.success) {
                    $container.find('.flight-check-result .flight-info-box').html(`<strong>Flight not found:</strong> ${response.error || 'No flights found for the details entered.'}`);
                    $container.find('.flight-check-result').removeClass('hidden');
                    $checkedInput.val('false');
                    $resultJsonInput.val('');
                    return;
                }

                const isDeparture = fieldType === 'flightdeparture';
                $checkedInput.val('true');
                $resultJsonInput.val(JSON.stringify(response.flightDetails));

                if (response.transferWindowMessage !== '') {
                    if (response.isOutsideTransferWindow) {
                        $container.find('.flight-transfer-warning .alert').html(response.transferWindowMessage).addClass('alert-warning');
                    } else if (!response.isOutsideTransferWindow) {
                        $container.find('.flight-transfer-warning .alert').html(response.transferWindowMessage).addClass('alert-success');
                    }

                    $container.find('.flight-transfer-warning').removeClass('hidden');
                }

                YouLi.Trip.FlightTracking.RenderCheckedFlight($container);
            }

            YouLi.Trip.FlightTracking.RenderCheckedFlight = function ($container) {
                const $flightFieldContainers = $container || $('.flight-field-container');

                $.each($flightFieldContainers, function (index, container) {
                    const fieldType = $(container).data('field-type');
                    const $resultJsonInput = $(container).find('.flight-result-json-input, input[name$="CheckedFlightResultJson"]').first();
                    const jsonString = $resultJsonInput.val();

                    if (!jsonString || jsonString.trim() === '') {
                        return;
                    }

                    const r = JSON.parse(jsonString);
                    const isDeparture = fieldType === 'flightdeparture';
                    const headerLabel = isDeparture ? 'Departure' : 'Arrival';

                    let departureDate = r.scheduledDeparture;
                    let departureCity = `${r.departureAirport.cityName} (${r.departureAirport.airportCode})`;
                    let arrivalDate = r.scheduledArrival;
                    let arrivalCity = `${r.arrivalAirport.cityName} (${r.arrivalAirport.airportCode})`;

                    if (isDeparture) {
                        departureDate = `<strong>${departureDate}</strong>`;
                        departureCity = `<strong>${departureCity}</strong>`;
                    } else {
                        arrivalDate = `<strong>${arrivalDate}</strong>`;
                        arrivalCity = `<strong>${arrivalCity}</strong>`;
                    }


                    let infoHtml = `<strong>${headerLabel} Flight found:</strong><br>`;
                    infoHtml += `<strong>Scheduled Departure:</strong> ${departureDate}<br>`;
                    infoHtml += `<strong>From City (Airport):</strong> ${departureCity}<br>`;
                    infoHtml += `<strong>Country:</strong> ${r.departureAirport.countryName}<br>`;
                    infoHtml += `<strong>Scheduled Arrival:</strong> ${arrivalDate}<br>`;
                    infoHtml += `<strong>To City (Airport):</strong> ${arrivalCity}<br>`;
                    infoHtml += `<strong>Country:</strong> ${r.arrivalAirport.countryName}<br>`;

                    $(container).find('.flight-check-result .flight-info-box').html(infoHtml);
                    $(container).find('.flight-check-result').removeClass('hidden');
                });
            }

            YouLi.Trip.FlightTracking.ResetFlightCheckResult = function ($container) {
                $container.find('.flight-checked-input, input[name$="FlightChecked"]').val('false');
                $container.find('.flight-result-json-input, input[name$="CheckedFlightResultJson"]').val('');
                $container.find('.flight-check-result').addClass('hidden');
                $container.find('.flight-transfer-warning').addClass('hidden');
            }

            YouLi.Trip.FlightTracking.CheckFlight = function ($btn) {
                const $container = $btn.closest('.flight-field-container');
                const fieldType = $container.data('field-type');
                const tripId = $btn.data('trip-id') || $('#TripId').val() || '';

                const $dateInput = $container.find('.flight-field-date-input, input[name$="FlightDate"]').first();
                const $airlineInput = $container.find('select[name$="FlightAirlineCode"]').first();
                const $flightNumberInput = $container.find('input[name$="FlightNumber"]').first();

                const flightDate = $dateInput.val();
                const airlineCode = $airlineInput.val();
                const flightNumber = $flightNumberInput.val();


                $btn.prop('disabled', true).html('<i class="fa fa-spinner fa-spin"></i> Verifying...');
                $container.find('.flight-check-result').addClass('hidden');
                $container
                    .find('.flight-transfer-warning')
                    .addClass('hidden')
                    .find('.alert')
                    .removeClass('alert-warning')
                    .removeClass('alert-success');

                YouLi.Trip.FlightTracking.ResetFlightCheckResult($container);

                YouLi.Common.Get({
                    url: '/Trip/CheckFlight',
                    params: {
                        airlineCode: airlineCode,
                        flightNumber: flightNumber,
                        flightDate: flightDate,
                        tripId: tripId,
                        fieldType: fieldType
                    },
                    errorCallback: function () {
                        $btn.prop('disabled', false).html('<i class="fa fa-search"></i> Verify Flight');
                        YouLi.Common.UI.ShowStandardDialog('An error occurred while checking the flight. Please try again.');
                    },
                }).then(function (response) {
                    renderFlightCheckResult($container, response);
                }).finally(function () {
                    $btn.prop('disabled', false).html('<i class="fa fa-search"></i> Verify Flight');
                });
            }

            YouLi.Trip.FlightTracking.InitFlightCheckButtons = function (scopeSelector) {

                if(!YouLi.Trip.FlightTracking.Enabled) {
                    return;
                }

                const scope = scopeSelector || document;

                $(scope).off('click', '.btn-check-flight').on('click', '.btn-check-flight', function () {
                    YouLi.Trip.FlightTracking.CheckFlight($(this));
                });

                $(scope)
                    .off('dp.change', '.flight-field-date-container.datepicker, input[name$="FlightDate"]')
                    .on('dp.change', '.flight-field-date-container.datepicker, input[name$="FlightDate"]', function (e) {
                        const $container = $(this).closest('.flight-field-container');

                        // Ignore initialization-like events where no previous value exists
                        if (!e || !e.oldDate) {
                            toggleCheckFlightState($container);
                            return;
                        }

                        YouLi.Trip.FlightTracking.ResetFlightCheckResult($container);
                        toggleCheckFlightState($container);
                    });

                $(scope).off('change', 'select[name$="FlightAirlineCode"]').on('change', 'select[name$="FlightAirlineCode"]', function () {
                    toggleCheckFlightState($(this).closest('.flight-field-container'));
                    YouLi.Trip.FlightTracking.ResetFlightCheckResult($(this).closest('.flight-field-container'));
                });

                $(scope).off('change', 'input[name$="FlightNumber"]').on('change', 'input[name$="FlightNumber"]', function () {
                    toggleCheckFlightState($(this).closest('.flight-field-container'));
                    YouLi.Trip.FlightTracking.ResetFlightCheckResult($(this).closest('.flight-field-container'));
                });

                $(scope)
                    .off('dp.show', '.flight-field-date-container.datepicker, input[name$="FlightDate"]')
                    .on('dp.show', '.flight-field-date-container.datepicker, input[name$="FlightDate"]', function () {
                        const $defaultDate = $(this).closest('.flight-field-container').find('.flight-field-date-container').first();
                        const defaultDate = $defaultDate.data('default-date');
                        const $flightDate = $(this).closest('.flight-field-container').find('.flight-field-date-input, input[name$="FlightDate"]').first();

                        if (defaultDate && $flightDate.val() === "") {
                            $defaultDate.data('DateTimePicker').defaultDate(moment(defaultDate, 'DD/MM/YYYY'));
                            $flightDate.val('');
                        }
                    })

                toggleCheckFlightState($(scope));
            }

        }(YouLi.Trip.FlightTracking ? YouLi.Trip.FlightTracking : {}));
    }(YouLi.Trip ? YouLi.Trip : {}));
}(YouLi ? YouLi : {}));